/* eslint-disable @typescript-eslint/no-var-requires */

export const ModalBgXS = require('./modal-bg-xs.png');
export const ModalBgSM = require('./modal-bg-sm.png');
